import {
  CompanyUser,
  CompanyUserRole,
  CompanyUserState,
  ProjectState,
} from './__generated__/_/graphql-mapped';

export * from './__generated__/_/gql';

export * from './__generated__/_/graphql-mapped';

export * from './__generated__/_/fragment-masking';

export const projectStateDisplayMap: Record<ProjectState, string> = {
  draft: 'Draft',
  publishing: 'Publishing',
  published: 'Live',
  archived: 'Archived'
};

export const projectStateColourMap: Record<ProjectState, string> = {
  draft: '#DA892B',
  publishing: '#DA892B',
  published: '#3EB077',
  archived: '#70808E'
};

export const getCompanyUserState = (cu: CompanyUser): CompanyUserState => {
  if (cu.deletedAt) return CompanyUserState.deleted;
  if (!cu.invitation) return CompanyUserState.joined;
  return new Date(cu.invitation.expiresAt) > new Date()
    ? CompanyUserState.invited
    : CompanyUserState.expired;
};

export const companyUserStateDisplayMap: Record<CompanyUserState, string> = {
  invited: 'Invited',
  expired: 'Expired',
  joined: 'Joined',
  deleted: 'Deleted',
};

export const companyUserStateColourMap: Record<CompanyUserState, string> = {
  invited: '#DA892B',
  expired: '#E74A4A',
  joined: '#3EB077',
  deleted: '#70808E',
};

export const companyUserRoleDisplayMap: Record<CompanyUserRole, string> = {
  accountOwner: 'Account owner',
  admin: 'Admin',
  member: 'Member',
};